<template>
  <div class="pop-four">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box" v-html="$lang.f4_1_header"></div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div class="icon f4_main"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f4_2_header"></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2">
        </div>
      </div>
    </div>

    <!-- Big slider -->
    <sm-slider
      :slides="dataSlides.slides"
    ></sm-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f4_3_header"></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="lvl-section one-two">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3" v-html="$lang.f4_4_1_txt"></div>
        <div class="lvl-box pure-u-1-1 pure-u-md-2-3 big-dot-wrapper" v-html="$lang.f4_4_2_txt"></div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-1">
          <h2 v-html="$lang.f4_4_header"></h2>
        </div>
      </div>
    </div>

    <div class="lvl-section regular">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header b-n-r">
            <div class="b-nr-wrapper">
              <p><span class="border-nr">1</span></p>
            </div>
            <h4 v-html="$lang.f5_5_1_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f5_5_1_txt"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header b-n-r">
            <div class="b-nr-wrapper">
              <p><span class="border-nr">2</span></p>
            </div>
            <h4 v-html="$lang.f5_5_2_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f5_5_2_txt"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header b-n-r">
            <div class="b-nr-wrapper">
              <p><span class="border-nr">3</span></p>
            </div>
            <h4 v-html="$lang.f5_5_3_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f5_5_3_txt"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f4_5_header"></h2>
          <p v-html="$lang.f4_5_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div ref="scollBy" class="lvl-section multi-box">
      <!-- Overlay -->
      <transition name="overlay">
        <div v-if="(popOverlay > 0)" class="multi-overlay">
          <div class="close-icon">
            <div class="icon red-cross" v-touch:tap="closeOverlay"></div>
          </div>

          <div v-if="(popOverlay === 1)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_1_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_1_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_1_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 2)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_2_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_2_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_2_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 3)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_3_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_3_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_3_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 4)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_4_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_4_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_4_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 5)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_5_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_5_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_5_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 6)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_6_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_6_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_6_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 7)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_7_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_7_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_7_right"></div>
            </div>
          </div>

          <div v-if="(popOverlay === 8)" class="content pure-g">
            <div class="header pure-u-1-1">
              <h3 v-html="$lang.f4_box_over_8_header"></h3>
            </div>
            <div class="body left pure-u-1-2">
              <div v-html="$lang.f4_box_over_8_left"></div>
            </div>
            <div class="body right pure-u-1-2">
              <div v-html="$lang.f4_box_over_8_right"></div>
            </div>
          </div>

        </div>
      </transition>
      <div class="pure-g multi-group bottom-border">
        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_1"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_1_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(1)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_2"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_2_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(2)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_3"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_3_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(3)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_4"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_4_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(4)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

      </div>
      <div class="pure-g multi-group">

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_5"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_5_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(5)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_6"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_6_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(6)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_7"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_7_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(7)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

        <!-- Box -->
        <div class="lvl-box pure-u-1-2 pure-u-md-1-4">
          <div class="lvl-header">
            <div class="icon f4_4_8"></div>
          </div>
          <div class="lvl-body">
            <div class="multi-txt" v-html="$lang.f4_box_8_txt"></div>
          </div>
          <div class="btn white arrow" v-touch:tap="showOverlay(8)">
            <p v-html="$lang.f4_read_more"></p>
          </div>
        </div>

      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f4_ref_1"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f4_ref_2"></div>
          </div>
          <!--<div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">-->
            <!--<div class="lvl-body" v-html="$lang.f4_ref_3"></div>-->
          <!--</div>-->
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import BGSlider from '../../../components/small-slider'
import DataSlider from '../../../assets/data/fact_4_s.json'

export default {
  name: 'fact-four',
  data () {
    return {
      dataSlides: DataSlider,
      popOverlay: 0,
      showRefs: false
    }
  },
  props: {
    scrollBase: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    },
    showOverlay (id) {
      let self = this
      return () => {
        self.onShowOverlay(id)
      }
    },
    onShowOverlay (id) {
      if (this.popOverlay !== id) {
        this.popOverlay = id
        this.scrollToOverlayTop()
        this.$bus.$emit('FACT.OVERLAY.HIDE')
      }
    },
    scrollToOverlayTop () {
      if (this.scrollBase !== '') {
        this.$nextTick(() => {
          this.$scrollTo(this.$refs.scollBy, '500', {container: ('#' + this.scrollBase)})
        })
      }
    },
    closeOverlay () {
      let self = this
      return self.onCloseOverlay()
    },
    onCloseOverlay () {
      this.popOverlay = 0
      this.$bus.$emit('FACT.OVERLAY.SHOW')
    }
  },
  components: {
    'sm-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/facts/fact4/index.vue